<template>
    <div class="footer font-normal">
        <v-container grid-list-lg>
            <v-layout row>
                <v-flex xs12 sm12>
                    <div class="logo">
                        <v-responsive>
                            <v-img height="100px"></v-img>
                        </v-responsive>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm12 lg8>
                    <v-layout row>
                        <v-flex xs4 sm4 md4>
                            <template v-for="(item, index) in items_l">
                                <v-list-item
                                    :key="index"
                                    :to="item.url"
                                    class="pl-0"
                                >
                                    <v-list-item-content
                                        style=" color: white; font-size: 1.5rem;"
                                        >{{ item.title }}</v-list-item-content
                                    >
                                </v-list-item>
                            </template>
                        </v-flex>
                        <v-flex xs4 sm4 md4>
                            <template v-for="(item, index) in items_r">
                                <v-list-item
                                    :key="index"
                                    :to="item.url"
                                    class="pl-0"
                                >
                                    <v-list-item-content
                                        style="color: white; font-size: 1.5rem;"
                                        >{{ item.title }}</v-list-item-content
                                    >
                                </v-list-item>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4 class="social-media">
                    <v-layout
                        row
                        class="justify-end align-center align-content-space-between"
                    >
                        <a
                            href="https://www.linkedin.com/company/project-athena-covid-19/about/"
                            target="_blank"
                            class="pt-4 pr-3"
                        >
                            <div class="linkedin-logo mr-5"></div>
                        </a>

                        <a
                            href="https://github.com/alexander-stage/athena"
                            target="_blank"
                            class="pt-4 pr-3"
                        >
                            <div class="github-logo mr-5"></div>
                        </a>
                        <a
                            href="https://projectathenaco.slack.com/join/shared_invite/zt-f3p49y0w-u0im1B3nAdyD8CKOTqtMtA"
                            target="_blank"
                            class="pt-4 pr-3"
                        >
                            <div class="slack-logo mr-5"></div>
                        </a>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'HomeFooter',
    data() {
        return {
            appTitle: 'Meal Prep',
            drawer: false,
            items_l: [
                { title: 'Home', url: '/' },
                // { title: 'Projects', url: '/projects' },
                { title: 'How it works', url: '/how-it-works' }
            ],
            items_r: [
                // { title: 'Slack guidelines', url: '/slack-guidelines' },
                { title: 'About', url: '/about' },
                { title: 'Join', url: '/join' }
            ]
        };
    },
    computed: {},
    methods: {}
};
</script>

<style scoped>
@import '../assets/styles/variables.scss';
@import '../assets/styles/main.css';

.footer {
    min-height: 320px;
    background: #003f5c;
}

.logo {
    background: url('../assets/img/logowhite2.png') no-repeat;
    background-size: contain;
    width: 100%;
}

.github-logo {
    background: url('../assets/img/github-circle@2x.png') no-repeat;
    background-size: contain;
    width: 100%;
    pointer-events: all;
    height: 80px;
}

.linkedin-logo {
    background: url('../assets/img/sm_li.svg') no-repeat;
    background-size: contain;
    width: 85%;
    pointer-events: all;
    height: 75px;
}

.slack-logo {
    background: url('../assets/img/Slack_Mark_Monochrome_White.png') no-repeat;
    background-size: contain;
    width: 100%;
    pointer-events: all;
    height: 80px;
}

.menu-item {
    text-decoration: none;
    color: inherit;
}

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

li {
    margin-top: 1rem;
    color: white;
}

a {
    padding-left: 0em;
    margin-left: 0em;
}
</style>
